import React, { 
  FunctionComponent, useContext, useEffect, useState 
} from 'react';
import {
  Box,
  Breadcrumbs,
  Grid,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
  Theme,
  Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { 
  Link as RouteLink, useHistory, useParams 
} from 'react-router-dom';
import { Favorite, Share } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { filter, union, isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { 
  getAllCatalogsAction, getArticlesById, getCatlogsAction, getFilterAction, getLanguageAction, usePorducts 
} from '@ivymobi/orbit-core/business/productCenter';
import { getOutCatlogsAction } from '@ivymobi/orbit-core/business/user';
import wx from 'weixin-js-sdk'
import { hashMapTree, getBreadcrumbsPath, getDisplayNodeIds } from './tools/index'

import QuickStart from '../dashboard/quickStart';
import Menus, { OpenMenuItem } from '../components/views/menuItem';
import RichText from '../components/richText/RichTextRenderer';
import { DeviceType, UserContext, TenantContext } from '../orbit-context';
import Loader from '../components/loaders';
import { Loading } from '../components';
import ProductItem from '../products/components/productItem';

import PopZtree from './components/popZtree';
import ZTree from './components/zTree';
import SearchInput from './components/searchInput';
// import parseISOWithOptions from 'date-fns/fp/parseISOWithOptions';
// import FilterView from './component/filterView';
// import { getTitle, getTitleById } from './mapping';
// import PopZtree from './component/popZtree';
// import fullTexts from './fullTexts';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'row',
    height: '100%',
    paddingTop: '10px'
  },
  sliderBar: {
    display: 'flex',
    flexDirection:'column',
    width:'25%',
    height: '100%',
    minWidth: '246px',
    flexShrink: 0,
    // paddingTop:theme.spacing(1),
    paddingBottom:theme.spacing(2)
  },
  content:{
    position: 'relative',
    overflow: 'auto',
    flexGrow: 1,
    flexBasis: 0,
    display: 'flex',
    // justifyContent:'center',
    alignItems: 'center',     
    flexDirection: 'column',
    overflowY: 'scroll',
    // "@media (min-width: 768px)": {
    //   paddingTop:theme.spacing(1),
    // }, 
    // "@media (max-width: 768px)": {
    //   marginTop:theme.spacing(1),
    //  },
    paddingBottom:theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px'
  }
}));

const queryParse = (query)=>{
  query = query.substring(query.indexOf('?') + 1);
  let array = query.split("&")
  let params = {};
  array.forEach(item => {
    let key = item.substring(0,item.indexOf('='));
    let value = decodeURIComponent(item.substring(item.indexOf('=') + 1));
    params[key] = value;
  });
  return params;
}

export const ProductsView = (props: any) => {
  const { handleShare, handleFav,searchText:search} = props;
  const { id, extra } = useParams<any>() ?? {id: null};
  console.log("========",search)
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const user = useContext(UserContext);
  const tenant = useContext(TenantContext);
  const deviceType = useContext(DeviceType);
  const classes = useStyles();
  const history = useHistory();
  let params = queryParse(location.search);
  
  const [showData, setShowData] = useState(null)
  const [curCatalog, setCurCatalog] = useState({});
  const [displayNodes, setDisplayNodes] = useState([]); // 需要渲染的节点 id

  const [selectInfo, setSelectInfo] = useState({show: false, item: null, target: null});
  const [[anchorEl, selectId], setAnchorEl] = useState([null, null]);
  const [loading, setLoading] = useState(false)
  const [searchText, setSearchText] = useState(search??'');
  const [result, setResult] = useState({result: [], onRefresh: false});
  const [extraBreadcrumbs, setExtraBreadcrumbs] = useState([]);
  const [customFilter, setCustomFilter]=useState('');
  const [searchResult, setSearchResult] = useState([]);

  const [defaultOpenSideBar, setDefaultOpenSideBar] = useState(false);
  
  useEffect(() => {
    // console.log('paramsparamsparamsparamsparamsparamsparamsparams', _.isNil(params.search));
    setDefaultOpenSideBar(!_.isNil(params.search));
  }, []);


  useEffect(()=>{
    setSearchText(search??'')
  },[search])
  const handleClickItem = (item) => {
    const _id = item.id
    if (item.type === "catalog") {
      history.push(`/products/${_id}`)
    } else if (item.type === 'product') {
      history.push(`/productDetail/${_id}`)
    }    
  }

  // 查询文档路径 
  // useEffect(() => {
  //   let selectText = null;
  //   for (let i = 0; i < fullTexts.length; i++) {
  //     if (fullTexts[i].name === curCatalog?.cgName?.zh) {
  //       selectText = fullTexts[i];
  //     }
  //   }
  //   if (selectText === null) {
  //     setRichText(null);
  //     return;
  //   }
  //   dispatch(getArticlesById({user:{token: null, user: null}, tenant:{id: tenant.id}, id: selectText.id})).then((res) => {
  //     console.log("======res===",res.data[0])
  //     setRichText(res.data[0]);
  //   })
  // }, [curCatalog])

  const requestAllCatalogs = () => {
    dispatch(getAllCatalogsAction({id: tenant.id})).then((allCatalogs) => {
      // console.log('all catalogs = ', allCatalogs)
      const _allcats = filter(allCatalogs, (item) => {
        if (item.csIndex === '0') return false;
        return true;
      });
      setShowData(_allcats);
    });
  };

  // 根据字符串搜索内容
  const requestData = () => {
    if(!tenant) return;
    setLoading(true)
    dispatch(getOutCatlogsAction({tenantId: tenant.id, id, shorturl: (customFilter && customFilter.length > 0) ? encodeURI(customFilter) : null})).then((allProductsInfos) => { 
      // console.log('请求数据 allProductsInfos =---- ', allProductsInfos)
      setCurCatalog(allProductsInfos)
      // setCurLanguage(language[allProductsInfos.csName])

      const _allcats = filter(allProductsInfos.catalogs, (item) => {
        if (item.csIndex === '0') return false;
        return true;
      });
      _allcats.map(item => {
        item.type = 'catalog';
      });
      if (allProductsInfos.productsData) {
        allProductsInfos.productsData.map(item => {
          item.type = 'product';
        });
      }
      setResult({ result: union(_allcats, allProductsInfos.productsData), onRefresh: true });
      // console.log('result === ', _allcats, allProductsInfos.productsData)
      setLoading(false)
    }, (e) => {
      console.log(e)
      setLoading(false)
    });
  };
  const SearchProduct = ()=>{
    if(!tenant) return;
    setLoading(true);
    dispatch(getOutCatlogsAction({tenantId: tenant.id, nameFilter: searchText, id, shorturl: (customFilter && customFilter.length > 0) ? encodeURI(customFilter) : null})).then((allProductsInfos) => { 
      // console.log('请求数据 allProductsInfos =---- ', allProductsInfos)
      setCurCatalog(allProductsInfos)
      // setCurLanguage(language[allProductsInfos.csName])

      const _allcats = filter(allProductsInfos.catalogs, (item) => {
        if (item.csIndex === '0') return false;
        return true;
      });
      _allcats.map(item => {
        item.type = 'catalog';
      });
      if (allProductsInfos.productsData) {
        allProductsInfos.productsData.map(item => {
          item.type = 'product';
        });
      }
      setSearchResult(union(_allcats, allProductsInfos.productsData));
      // console.log('result === ', _allcats, allProductsInfos.productsData)
      setLoading(false)
    }, (e) => {
      console.log(e)
      setLoading(false)
    });
  }
  // const getExistFilter = (pre,filter)=>{
  //   if(!pre)
  //     return;
  //   for(let m=0;m<filter.length;m++){
  //     let fOption =  filter[m];
  //     for(let preM=0;preM<pre.length;preM++){
  //       let preOption =  pre[preM];
  //       //大类相同 IF0000
  //       if(fOption[0]===preOption[0]){
  //         console.log("IF0000==",fOption[0])
  //           for(let i=0;i<fOption[1].length;i++){
  //             let item = fOption[1][i];
  //             for(let preI=0;preI<preOption[1].length;preI++){
  //               let preItem = preOption[1][preI];
  //               console.log("item== 1==preItem",item ,preItem )

  //               if(item[0]===preItem[0]){ 
  //                 item[2] = preItem[2];
  //                 item[3] = preItem[3];
  //                 item[4] = preItem[4];
  //                 item[5] = preItem[5];
  //                 item[6] = preItem[6];
  //                 item[7] = preItem[7];
                
  //               }
  //             }
  //           }
  //       }
  //     }
  //   }
  // }

  // const RequestFilter = () => {
  //   if (!id)
  //     return;
  //   dispatch(getFilterAction({user:{token:null,user:null}, tenant:{id:webInfo.tnt_id}, id,shorturl:customFilter&&customFilter.length>0?encodeURI(customFilter):null})).then((_filter) => {
  //     let ops = [];
  //     for(let i=0;i<_filter.options.length;i++){
  //       if(_filter.options[i][0]==='IF000003'||_filter.options[i][0]==='IF000004'|| _filter.options[i][0]==='IF000005'|| _filter.options[i][0]==='IF000006'|| _filter.options[i][0]==='IF000007'){
  //           ops.push(_filter.options[i])
  //       }
  //     }
  //     let resu = _.sortBy(ops,function(item){
  //       return  item[0]
  //     })
  //     getExistFilter(mFilter,resu)


  //     setMFilter(resu);
  //     // console.log("pr11e====",pre,filter)
  //   });
  // };

  // useEffect(() => {
  //   if(!tenant) return;
  //   RequestFilter()
  //   setCustomFilter('')
  // }, [tenant, id])

  // useEffect(() => {
  //   if (!webInfo || !language)
  //     return;
  //   RequestFilter()  
  // }, [ id, webInfo,language, customFilter]);

  // 请求整个产品树状结构数据
  useEffect(() => {
    if (!tenant && !id) return;  
    requestAllCatalogs();
  }, [tenant.id,id])

  // 请求当前层级的产品数据
  useEffect(() => {
    if (!tenant.id) return;
    requestData();
  }, [id, tenant.id, customFilter]);
  useEffect(() => {
    if (!tenant.id ) return;
    SearchProduct();
  }, [searchText]);

  useEffect(() => {
    if (!tenant) return;
    if (isEmpty(showData)) return;
    // console.log('--showData---curCatalog---->>>>>>', showData, curCatalog)
    // 组装面包屑，先将树扁平化，这样方便通过 id 来查询
    console.log('开始扁平化')
    var resultMap = {};
    hashMapTree(showData, resultMap);
    console.log('result map = ', resultMap)
    var breadcrumbs = [];
    getBreadcrumbsPath(resultMap, curCatalog?.id, breadcrumbs);
    breadcrumbs.reverse();
    console.log('breadcrumbs = ', breadcrumbs)
    setExtraBreadcrumbs(breadcrumbs);
    // 遍历要渲染的节点id
    var nodeIds = [];
    getDisplayNodeIds(resultMap, nodeIds, breadcrumbs);
    // console.log('要渲染的节点 = ', nodeIds);
    setDisplayNodes(nodeIds);
  }, [showData, curCatalog?.id])

  const handleMenuClose = () => {
    setAnchorEl([null, null]);
  };

  useEffect(() => {
    if (isEmpty(user)&&((window.top===window.self))&&window.WeixinJSBridge==undefined) return;
    if (selectInfo.target === null) return;
    setAnchorEl([selectInfo.target, selectInfo.item.type === 'catalog' ? selectInfo.item.cgId : selectInfo.item.details.supplierAltPid]);
  }, [selectInfo]);

  if(!tenant || !curCatalog || !showData || !displayNodes) {
    return (<Loader/>)
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem dense onClick={() => { 
          handleMenuClose();
          if(window.WeixinJSBridge){
            wx.miniProgram.navigateTo({
              url: `/pages/documents/documentShare?id=${selectInfo.item.type === 'catalog' ? selectInfo.item.cgId : (selectInfo.item.type === 'product' ? selectInfo.item.details.supplierAltPid : selectInfo.item.id)}`
            });
            return;
          }
           if(window.self!=window.top){
              window.parent.postMessage({type:'share',item:selectInfo.item},'*');
             return;
            } 
          handleShare(); 
           }}>
          <ListItemIcon>
            <Share fontSize='small' />
          </ListItemIcon>
          <Typography>分享</Typography>
        </MenuItem>
        <MenuItem onClick={() => {
          handleMenuClose();
          if (window.WeixinJSBridge) {
            wx.miniProgram.navigateTo({
              url: `/pages/favorites/addToFavorites?did=${selectInfo.item.type === 'catalog' ? selectInfo.item.cgId : (selectInfo.item.type === 'product' ? selectInfo.item.details.supplierAltPid : selectInfo.item.id)}&type=product`,
            });
            return;         wx.miniProgram.navigateTo({
              url: `/pages/documents/documentShare?id=${selectInfo.item.type === 'catalog' ? selectInfo.item.cgId : (selectInfo.item.type === 'product' ? selectInfo.item.details.supplierAltPid : selectInfo.item.id)}`
            });
            return;
          }
          if(window.self!=window.top){
            window.parent.postMessage({type:'collection',item:selectInfo.item},'*');
           return;
          } 
          handleFav();  }}>  
          <ListItemIcon>
            <Favorite fontSize='small' />
          </ListItemIcon>
          <Typography>收藏</Typography>
        </MenuItem>
      </Menu>
      
      {deviceType === 'desktop' && <Breadcrumbs style={{height:'30px', display:'flex', alignItems:'center'}} separator=">" maxItems={8}>
        <Link color='textPrimary' to={'/'} component={RouteLink}>{t('menu.dashboard')}</Link>
        <Link color='textPrimary' to={'/products'} component={RouteLink}>{t('menu.products')}</Link>
        {extraBreadcrumbs && extraBreadcrumbs.length && extraBreadcrumbs.map((item, i) => {
          if (extraBreadcrumbs.length === i + 1) {
            return <Typography key={id}>{item.name}</Typography>;
          }
          return (
            <Link color='textPrimary' key={item.id} to={item.id ? '/products/' + item.id : null} component={RouteLink}>
              {item.name}
            </Link>
          )
        })}
      </Breadcrumbs>}


      <Box className={classes.pages} style={{ height: deviceType === 'desktop' ? 'calc(100% - 30px)' : '100%' }}>

        {deviceType === 'desktop' && <Box className={classes.sliderBar}>
          <SearchInput searchText={searchText} doSearch={(value) => { setSearchText(value); }} />
          {showData && displayNodes && displayNodes.length > 0 && 
          <ZTree data={(searchText==null||searchText?.length==0)?showData:searchResult} displayNodes={displayNodes} breadcrumbs={extraBreadcrumbs} curCatalog={curCatalog} setCurCatalog={setCurCatalog} />}
        </Box>}

        <Box className={classes.content}>
          {/* {id && <Box style={{width:'90%',marginBottom:'10px'}}>
            <FilterView richText={richText} id={id} curCatalog={curCatalog} setCustomFilter={setCustomFilter} language={curLanguage} filter={mFilter}
              OnExtra={() => {
                console.log("curCatalog==",curCatalog)
                history.push(`/${params.catalogType}/product/${curCatalog.id}/info/?catalogType=${params.catalogType}`)
              }}
            />
          </Box>} */}

          <Box className='products' style={{ 
            position: 'absolute', 
            left: 0, 
            top: 0, 
            width:'100%', 
            height:'100%', 
            overflowY: 'scroll',
            overflowX: 'hidden' 
          }}>
            {deviceType==='mobile' && showData && displayNodes && displayNodes.length > 0 && 
              <PopZtree
                searchText={searchText}
                setSearchText={setSearchText} 
                data={(searchText==null||searchText?.length==0)?showData:searchResult}
                displayNodes={displayNodes}
                breadcrumbs={extraBreadcrumbs}
                curCatalog={curCatalog}
                setCurCatalog={setCurCatalog}
                defaultOpenSideBar={defaultOpenSideBar}
              />}
            <Grid container spacing={deviceType === 'desktop' ? 2 : 1} style={{ paddingLeft: deviceType === 'desktop' ? '10px' : 0 }}>
              {result.result.map((item) => ( 
                <Grid 
                  item 
                  key={item.id} 
                  xs={deviceType === 'desktop' ? 6 : 6} 
                  sm={deviceType === 'desktop' ? 6 : 6} 
                  md={deviceType === 'desktop' ? 4 : 6}
                  lg={deviceType === 'desktop' ? 3 : 6}
                >
                  <ProductItem setSelectInfo={setSelectInfo} item={item} onClick={() => { handleClickItem(item) }} />
                </Grid>
              ))}
            </Grid>
          </Box>
          {loading && <Loading/>} 
        </Box>
      </Box>
    </div> 
  );
};

export default function ProductsContainer ({handleShare, handleFav,searchText}) {
  return (
    <ProductsView handleShare={handleShare} handleFav={handleFav} searchText={searchText}/>
  );
}